import { createFileRoute } from "@tanstack/react-router";

import { ShopperAccountsPage } from "../../../features/storefront/shopper-accounts-page";

export const Route = createFileRoute("/_app/customers/online-accounts")({ component: ShopperAccountsPage });
